import React from "react";
import { ContractData } from "@/pages/contracts/types";
import { EntityType } from "@/services/hooks/entities/useEntityType";
import ContractDetailFields from "./ContractDetailFields";
import { ContractFieldUpdate } from "./ContractDetailedView";
import ContractKPIs from "@/pages/contracts/components/ContractKPIs";
import NextSteps from "@/components/layouts/NextSteps/NextSteps";
import Ownership from "@/components/layouts/Ownership";

interface Props {
  contract: ContractData;
  onUpdateField: ContractFieldUpdate;
  toggleTasksDrawer?: () => void;
}

const ContractOverview: React.FC<Props> = ({
  contract,
  onUpdateField,
  toggleTasksDrawer
}) => {
  return (
    <div
      className="w-full flex flex-col gap-6"
      data-test="contract-detailed-view-overview"
    >
      <ContractKPIs contract={contract} onUpdateField={onUpdateField} />
      <div className="w-full flex gap-6">
      <div className="flex-1">
        <ContractDetailFields
          contract={contract}
          onUpdateField={onUpdateField}
          containerClassName="grid-cols-[minmax(0,30%),1fr]"
        />
      </div>
      <div className="flex-1 flex flex-col gap-6">
        <NextSteps
          entity={contract}
          entityType={EntityType.CONTRACT}
          toggleTasksDrawer={toggleTasksDrawer}
        />
        <Ownership
          entity={contract}
          entityType={EntityType.CONTRACT}
          onUpdateField={onUpdateField}
          className="h-fit"
        />
      </div>
      </div>
    </div>
  );
};

export default ContractOverview;
